import Url from 'domurl';
import {createBrowserHistory} from 'history';
import noUiSlider from 'nouislider';

require('jQuery.serializeObject');
const history = createBrowserHistory();

/**
 * Synchronize state of the old form to the new form
 * @param {jQuery} $old
 * @param {jQuery} $new
 */
const syncFormState = ($old, $new) => {
    // Synchronize more/less toggled state
    $('.filters__block', $old).each(function() {
        const $oldTitle = $('.js-filter-title', this);
        const $newBlock = $('.filters__block', $new).filter(function() {
            return $('.js-filter-title', this).text() === $oldTitle.text();
        });

        // Toggle title collapse state
        const $newTitle = $('.js-filter-title', $newBlock);
        $newTitle.toggleClass('is-collapse', !$oldTitle.next().is(':visible'));
        $newTitle.next().toggle($oldTitle.next().is(':visible'));

        // Toggle more/less viewing
        const $oldMore     = $('.js-filter-more', this);
        const moreExpanded = $oldMore.length > 0 && !$oldMore.is(':visible');
        if (moreExpanded) {
            $('.js-filter-more', $newBlock).hide();
            $('.js-filters-outside-max', $newBlock).css('display', 'block');
            $('.js-filter-less', $newBlock).show();
        }
    });

    // Sync mobile filter state
    const $oldFilterSection = $old.closest('#filter');
    $new.closest('#filter').toggleClass('is-active', $oldFilterSection.hasClass('is-active'));
};

/**
 * Get all query parameter names from form inputs
 * @param {jQuery} $form
 * @returns {String[]}
 */
const formParams = ($form) => {
    const params = [];
    $(':input[name]', $form).each(function() {
        const name = $(this).attr('name');
        const p    = name.substr(0, name.indexOf('[') > 0 ? name.indexOf('[') : name.length);
        if (params.indexOf(p) === -1) {
            params.push(p);
        }
    });
    return params;
};

/**
 * Load current filters of the given form onto the current page
 * @param {jQuery} $form
 */
const loadFilters = ($form) => {
    // Persist query parameters that are not part of the filter values (except page)
    let url = new Url;
    delete url.query['filter'];
    delete url.query['page'];

    const values = $form.serializeObject();
    url.query    = $.param({...url.query, ...values});
    loadUrl($form, url);
};

/**
 * Load a specific URL for a filter form
 *
 * @param {jQuery} $form The form with filters to load for
 * @param {String|Url} url The URL to load
 */
const loadUrl = ($form, url) => {
    // Set loading state to form and extra containers
    $form.addClass('loading');
    const loadingSelector = $form.data('load');
    if (loadingSelector !== undefined) {
        $(loadingSelector).addClass('loading');
    }

    let xhr = $form.data('xhr');
    if (xhr !== undefined) {
        xhr.abort();
    }

    if (typeof url === 'string') {
        url = new Url(url);
    }

    xhr = $.ajax({
        url: url.toString(),
    }).done((data, statusText, xhr) => {
        let $target   = $('body > .wrapper > main');
        let $contents = $(data);
        if ($form.data('target')) {
            $target   = $($form.data('target'), $target);
            $contents = $($form.data('target'), $contents).children();
        }

        const $oldForm = $form;
        $form          = $('form.js-filters', $contents) || $form;
        syncFormState($oldForm, $form);

        const updateHistory = $form.data('history') === undefined ? true : $form.data('history');
        if (updateHistory) {
            let search = $.isEmptyObject(url.query) ? false : '?' + url.query.toString();

            const currentFilterHash = (new Url).query.filter || undefined;
            const filterHash        = xhr.getResponseHeader('App-Filter-Hash');
            if (typeof filterHash === 'string' && filterHash.length > 0) {
                let urlWithHash          = new Url('');
                urlWithHash.query.filter = filterHash;

                // Persist pagination params
                ['sort', 'direction', 'limit'].forEach((param) => {
                    if (url.query.hasOwnProperty(param)) {
                        urlWithHash.query[param] = url.query[param];
                    }
                });
                // Persist page only when filter hash did not change
                if (currentFilterHash === filterHash) {
                    if (url.query.hasOwnProperty('page')) {
                        urlWithHash.query['page'] = url.query['page'];
                    } else {
                        delete urlWithHash.query['page'];
                    }
                }

                search = '?' + urlWithHash.query.toString();
            }
            history.replace(updateHistory === true ? {pathname: url.path, search: search} : updateHistory);
        }

        $target.html('').append($contents);
        window.app.loadComponentsFor($target);
    }).always(() => {
        $form.removeClass('loading');
        if (loadingSelector) {
            $(loadingSelector).removeClass('loading');
        }
    }).fail((xhr) => {
        if (xhr.statusText === 'abort') {
            return;
        }
        alert('Er ging iets mis met het filteren. Herlaad de pagina en probeer het opnieuw.');
    });

    $form.data('xhr', xhr);
}

export default ($container) => {
    // Toggle blocks with titles
    $('.js-filter-title', $container).click(function(e) {
        e.preventDefault();
        $(this).toggleClass('is-collapse');
        $(this).next().slideToggle('fast');
    });

    // AJAX filter submission
    $('form.js-filters:not(.js-filters-no-ajax)', $container).each(function() {
        const $form = $(this);
        $form.on('submit', function(e) {
            e.preventDefault();
            loadFilters($(this));
        });

        // Autodetect current selection and sorting controls within loaded containers
        const loadingSelector = $form.data('load');
        if (loadingSelector !== undefined) {
            const $loadingContainer = $(loadingSelector, $container);
            $('.js-select-url.js-filter-sorting', $loadingContainer).off('change').on('change', function(e) {
                e.preventDefault();
                loadUrl($form, $(this).val());
            });
            $('.js-filter-sorting[href], .js-filter-selected[href], .pagination a[href]', $loadingContainer).on('click', function(e) {
                e.preventDefault();
                loadUrl($form, $(this).attr('href'));
            });
        }
    });

    // Handle range sliders
    $('.js-slider-control', $container).each(function() {
        noUiSlider.create(this, $(this).data('slider-options'));
        const $inputTarget = $($(this).data('target'));
        if ($inputTarget.length === 0) {
            return;
        }

        // Update labels
        this.noUiSlider.on('update', function(values) {
            const start = Math.floor(values[0]);
            const end   = Math.floor(values[1]);

            $inputTarget.each(function() {
                const value  = $(this).attr('name').indexOf('[from]') > -1 ? start : end;
                const $label = $(this).next('.js-range-label');
                if ($label) {
                    const mapping = $label.data('mapping') || {};
                    $label.text(mapping[value] || $label.data('format').replace('[value]', value));
                }
            });
        });

        // Synchronize values to input
        this.noUiSlider.on('change', function(values) {
            const start = Math.floor(values[0]);
            const end   = Math.floor(values[1]);
            $inputTarget.each(function() {
                const value = $(this).attr('name').indexOf('[from]') > -1 ? start : end;
                $(this).val(value);
            });
            $inputTarget.first().trigger('change');
        });
    });

    // Automatically submit on input value change
    $('form.js-filters :input', $container).on('change', function(e) {
        $(this).closest('form.js-filters').trigger('submit');
    });

    // Toggle maximum amount of filters
    $('.js-filter-less', $container).click(function(event) {
        event.preventDefault();
        let $filter = $(this).closest('.filters__block');
        $('.js-filter-more', $filter).show();
        $('.js-filters-outside-max, .js-filter-less', $filter).hide();
    });
    $('.js-filter-more', $container).click(function(event) {
        event.preventDefault();
        let $filter = $(this).closest('.filters__block');
        $('.js-filter-more', $filter).hide();
        $('.js-filters-outside-max, .js-filter-less', $filter).show();
    });

    // Clear all filters
    $('.js-clear-filter', $container).click(function(event) {
        let $form = $(this).closest('form');
        $(':input', $form).not(':button, :submit, :reset, :hidden, :checkbox, :radio').val('');
        $(':checkbox, :radio', $form).prop('checked', false);
        $form.trigger('submit');
    });

    // Toggle filter as sidebar on mobile
    $('.js-filter-open', $container).click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        let $href = $(this).attr('href');

        $($href).addClass('is-active');
        $('body, html, .wrapper, .header__container').addClass('is-active');
    });

    $('.js-filter-close', $container).click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        let $href = $(this).attr('href');

        $($href).removeClass('is-active');
        $('body, html, .wrapper, .header__container').removeClass('is-active');
    });

    $('.filters', $container).click(function(e) {
        e.stopPropagation();
    });

    if ($container.is('body')) {
        $('body, html, .wrapper', $container).click(function() {
            $('.filters, .header__container').removeClass('is-active');
        });
    }
};
